export const findObject = (object, id) => {
  let result
  if (object instanceof Array) {
    for (let i = 0; i < object.length; i++) {
      result = findObject(object[i], id)
    }
  } else {
    for (let prop in object) {
      if (prop === 'id') {
        if (object[prop] === id) {
          return object
        }
      }
      if (object[prop] instanceof Object || object[prop] instanceof Array) {
        result = findObject(object[prop], id)
      }
    }
  }
  return result
}

export const getImagePath = (path) => {
  if (path === undefined) {
    return '/static/img/news/default-210.png'
  }
  if (path.startsWith('http')) {
    return path
  }
  return `http://api.kopiketjil.com${path}`
}



// WEBPACK FOOTER //
// ./src/helpers/index.js